import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { GALLERY } from "../data";

export default function Gallery() {
  return (
    <section className="section gallery" id="galeri">
      <div className="container">
        <Reveal className="section-head">
          <div>
            <span className="eyebrow">Hasil yang terasa</span>
            <h2 className="h2">
              Dari kusam jadi
              <br />
              <em>kinclong kembali.</em>
            </h2>
          </div>
          <p>Perubahan yang membuat rumah terasa seperti tempat baru. Geser pandangan Anda dari before ke after.</p>
        </Reveal>
        <div className="gallery-grid">
          {GALLERY.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.1} className="ba-card">
              <article data-testid={`before-after-card-${i}`}>
                <div className="ba-pair">
                  <figure>
                    <img src={item.before} alt={`${item.title} sebelum dibersihkan`} loading="lazy" data-testid={`before-image-${i}`} />
                    <span className="ba-tag">BEFORE</span>
                  </figure>
                  <figure>
                    <img src={item.after} alt={`${item.title} sesudah dibersihkan`} loading="lazy" data-testid={`after-image-${i}`} />
                    <span className="ba-tag after">AFTER</span>
                  </figure>
                </div>
                <h3>{item.title}</h3>
                <a href="#pesan" className="card-link" data-testid={`gallery-booking-link-${i}`}>
                  Buat rumah Anda seperti ini <ArrowRight size={14} />
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
